// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__sA0RC","title":"AfterBackImages_title__1eE_X","images":"AfterBackImages_images__Qh3Sr"};